import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';

const BigInput = (props) => {
  const { height = '.45rem', style } = props;

  const initStyle = {
    height,
    borderRadius: 5,
    minHeight: 30
  };

  return (
    <Input
      {...props}
      style={{ ...initStyle, ...style }}
    />
  )
};

BigInput.propTypes = {
  props: PropTypes.object
}


export default BigInput;